import Page from './Layout/Page';

function App() {
    return (
        <div className="App">
            <Page />
        </div>
    );
}

export default App;
